import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import store from "../store";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import OportunityContent from "../views/OportunityContent.vue";
import Cv from "../views/Cv.vue";
import CvResult from "../views/CvResult.vue";
import Interviews from "../views/Interviews.vue";
import Interview from "../views/Interview.vue";
import NotFound from "../views/NotFound.vue";
import SignUp from "../views/SignUp.vue";
import NotAvailable from "../views/NotAvailable.vue";
import TrainingSample from "../views/TrainingSample.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/admin",
    name: "Admin",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Admin.vue")
  },
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      requiresAuth: false,
      customNavbar: true
    }
  },
  {
    path: "/signup",
    name: "signup",
    component: SignUp,
    meta: {
      requiresAuth: false,
      customNavbar: true
    }
  },
  {
    props: true,
    path: "/oportunity/:oid",
    name: "Oportunity",
    component: OportunityContent,
    redirect: {
      name: 'Interviews'
    },
    children: [
      {
        props: true,
        path: "interviews",
        name: "Interviews",
        component: Interviews
      },
      {
        props: true,
        path: "interviews/:iid",
        name: "Interview",
        component: Interview
      },
      {
        path: "networking",
        name: "Networking",
        component: NotAvailable,
        props: { 
          notAvailableImageContent: require("@/assets/TrackNotAvailable_Networking.png"),
          imageContent: require("@/assets/StudentsOnly_Networking.png") 
        }
      },
      {
        path: "offers",
        name: "Offers",
        component: NotAvailable,
        props: { 
          notAvailableImageContent: require("@/assets/TrackNotAvailable_Offers.png"),
          imageContent: require("@/assets/StudentsOnly_Offers.png") 
        }
      },
      {
        props: true,
        path: "cv",
        name: "Cv",
        component: Cv
      },
      {
        props: true,
        path: "cv/:cvid/result",
        name: "CvResult",
        component: CvResult
      },
      {
        props: true,
        path: "training",
        name: "Training",
        component: TrainingSample
      },
      {
        path: "tests",
        name: "Tests",
        component: NotAvailable,
        props: { 
          notAvailableImageContent: require("@/assets/TrackNotAvailable_Tests.png"),
          imageContent: require("@/assets/StudentsOnly_Offers.png") 
        }
      }
    ]
  },
  {
    path: '*',
    name: "NotFound",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some(
      record =>
        record.meta.requiresAuth !== undefined && !record.meta.requiresAuth
    )
  ) {
    next();
  } else {
    if (store.state.User.loggedIn) {
      next();
      return;
    }
    next({
      name: "Login",
      query: { redirect: to.fullPath }
    });
  }
});

export default router;
